import Client from '@/clients/apiClient';
import humps from 'humps';
import { stringify } from 'query-string';

export default {
  getCustomerTransactions(payload) {
    return Client.get(
      `/customer-transactions?page=${payload.page}&limit=${
        payload.perPage
      }&sort[field]=${humps.decamelize(payload.sort.field)}&sort[type]=${
        payload.sort.type
      }&${stringify(humps.decamelizeKeys(payload.filters))}`
    );
  },
  updateCustomerTransaction(transactionId, payload) {
    return Client.put(`/customer-transactions/${transactionId}`, payload);
  },
  postCapitronStatements(payload) {
    return Client.post('/customer-transactions/capitron-statements', payload);
  },
  getMainJournal(payload) {
    return Client.get(
      `/general-journals?page=${payload.page}&limit=${
        payload.perPage
      }&sort[field]=${humps.decamelize(payload.sort.field)}&sort[type]=${
        payload.sort.type
      }&${stringify(humps.decamelizeKeys(payload.filters))}`
    );
  },
};
